/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type HpRespCollectionsModuleOld_homepage$ref = any;
type HpRespEditorialModuleOld_homepage$ref = any;
type HpRespFeaturedModule_homepage$ref = any;
type HpRespHeroModuleOld_homepage$ref = any;
type HpRespInformationalContent_viewer$ref = any;
type HpRespLocationsModule_homepage$ref = any;
type HpRespLocationsModule_viewer$ref = any;
type HpRespPersonalizedCategories_personalization$ref = any;
type HpRespPersonalizedCategories_viewer$ref = any;
type HpRespPromoModulePrimaryOld_homepage$ref = any;
type HpRespPromoModuleSecondaryOld_homepage$ref = any;
type HpRespRecentlyViewedItems_itemEdges$ref = any;
type HpRespRecentlyViewedItems_user$ref = any;
type HpRespShopByModule_homepage$ref = any;
export type HpRespLayout_viewer$ref = any;
export type HpRespLayout_viewer = {
    readonly showNewHomepageLocationsModule: boolean | null;
    readonly homepage: {
        readonly personalization?: {
            readonly " $fragmentRefs": HpRespPersonalizedCategories_personalization$ref;
        } | null;
        readonly " $fragmentRefs": HpRespHeroModuleOld_homepage$ref & HpRespPromoModulePrimaryOld_homepage$ref & HpRespCollectionsModuleOld_homepage$ref & HpRespFeaturedModule_homepage$ref & HpRespPromoModuleSecondaryOld_homepage$ref & HpRespEditorialModuleOld_homepage$ref & HpRespShopByModule_homepage$ref & HpRespLocationsModule_homepage$ref;
    } | null;
    readonly user?: {
        readonly " $fragmentRefs": HpRespRecentlyViewedItems_user$ref;
    } | null;
    readonly items?: {
        readonly " $fragmentRefs": HpRespRecentlyViewedItems_itemEdges$ref;
    } | null;
    readonly " $fragmentRefs": HpRespPersonalizedCategories_viewer$ref & HpRespLocationsModule_viewer$ref & HpRespInformationalContent_viewer$ref;
    readonly " $refType": HpRespLayout_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
    } as any);
    return {
        "kind": "Fragment",
        "name": "HpRespLayout_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "homepageId",
                "type": "String"
            },
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "recentlyViewedItemIds",
                "type": "[String]"
            },
            {
                "kind": "RootArgument",
                "name": "hasRecentlyViewedItems",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": "showNewHomepageLocationsModule",
                "name": "isEnabled",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "showNewHomepageLocationsModule"
                    }
                ],
                "storageKey": "isEnabled(key:\"showNewHomepageLocationsModule\")"
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "homepage",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "rootId",
                        "variableName": "homepageId"
                    }
                ],
                "concreteType": "Homepage",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "HpRespHeroModuleOld_homepage",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "HpRespPromoModulePrimaryOld_homepage",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "HpRespCollectionsModuleOld_homepage",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "HpRespFeaturedModule_homepage",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "HpRespPromoModuleSecondaryOld_homepage",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "HpRespEditorialModuleOld_homepage",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "HpRespShopByModule_homepage",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "HpRespLocationsModule_homepage",
                        "args": null
                    },
                    {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "hasUserId",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "personalization",
                                "storageKey": null,
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 3
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "numItems",
                                        "value": 3
                                    },
                                    (v0 /*: any*/)
                                ],
                                "concreteType": "PersonalizationModuleConnection",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "HpRespPersonalizedCategories_personalization",
                                        "args": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "HpRespPersonalizedCategories_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "HpRespLocationsModule_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "HpRespInformationalContent_viewer",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/)
                        ],
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "HpRespRecentlyViewedItems_user",
                                "args": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasRecentlyViewedItems",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "itemIds",
                                "variableName": "recentlyViewedItemIds"
                            }
                        ],
                        "concreteType": "ItemsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "HpRespRecentlyViewedItems_itemEdges",
                                "args": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '0c33e37739c7427d56ab680e66ee4af8';
export default node;
